import {
  createResource,
  postResource,
} from '@resource/resource'
import { prefixAPI } from '@resource/api'

const REGISTRATION_CARD_LINK = prefixAPI('registration-card/{token}/')

export const registrationCardResource = createResource(
  REGISTRATION_CARD_LINK
)

/**
 * Ресурс сканування QR: URL приходить готовим з бекенду (context сторінки
 * сканера, `scan_api_url` — абсолютний шлях через `reverse()`), тому
 * ресурс створюється динамічно на переданому URL, без API_BASE_URL-префіксу.
 */
export const createCheckInScanResource = url => createResource(
  url, postResource
)
